import { render, staticRenderFns } from "./TheAppLinkBlock.vue?vue&type=template&id=2969d95b&"
import script from "./TheAppLinkBlock.vue?vue&type=script&lang=js&"
export * from "./TheAppLinkBlock.vue?vue&type=script&lang=js&"
import style0 from "./TheAppLinkBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports